import { combineReducers } from '@reduxjs/toolkit';

import { apiSlice } from './api/api-slice';
import AuthReducer from './auth/auth-slice';
import EditorReducer from './editor/editor-slice';
import uploadMediaReducer from './upload-media-analysis/upload-media-slice';

export const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,

  auth: AuthReducer,
  editor: EditorReducer,
  uploadMedia: uploadMediaReducer,
});
